import { Checkbox, Select } from "antd";
import { LuPencil } from "react-icons/lu";
import { Card } from "reactstrap";
import { EditBillingAddressModal } from "../modals/EditAddressModal";
import { useState } from "react";
import { useLocation } from "react-router-dom/cjs/react-router-dom";

const OrderBillingAddressCard = ({
  title,
  billingData,
  setBillingData,
  shippingCheckboxes,
  setShippingCheckboxes,
}) => {
  const { pathname } = useLocation();
  const route = pathname.split("/");
  // MODAL FUNCTIONALITY
  const [editBillingModal, setEditBillingModal] = useState(false);
  const toggleBillingModal = () => setEditBillingModal(!editBillingModal);
  const handleBillingEdit = () => {
    toggleBillingModal();
  };
  const handleBillingSave = (updatedData) => {
    setBillingData(updatedData);
    toggleBillingModal();
  };
  const handleCheckboxChange = (key, checked) => {
    const updatedCheckboxes = { ...shippingCheckboxes, [key]: checked };
    setShippingCheckboxes(updatedCheckboxes);
  };

  return (
    <>
      <EditBillingAddressModal
        modal={editBillingModal}
        toggle={toggleBillingModal}
        billingData={billingData}
        setBillingData={setBillingData}
        onSave={handleBillingSave}
      />
      <Card className="border-1 h-100 rounded-0 bg-light p-2  my-2 my-lg-0 billingShippingCard " >
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="primary-color">{title}</h5>
          <LuPencil className="pointer" onClick={handleBillingEdit} />
        </div>
        {billingData && Object.keys(billingData).length > 0 ? (
          <div className="fs-16">
            <p className="mb-0">{billingData?.company}</p>
            <p className="mb-0">
              {billingData?.first_name ?? ""} {billingData?.last_name ?? ""}
            </p>
            <p className="mb-0">{billingData?.address_1 ?? ""}</p>
            <p className="mb-0">{billingData?.address_2 ?? ""}</p>
            <p className="mb-0">
              {billingData?.city ?? ""} {billingData?.state ?? ""}{" "}
              {billingData?.postcode ?? ""}
            </p>
            <p className="mb-0">
              Ph:{" "}
              <span className="primary-color">{billingData?.phone ?? ""}</span>
            </p>
            <p className="mb-0 primary-color">{billingData?.email ?? ""}</p>

            {(route.includes("purchase-orders-details") ||
              route.includes("update-purchase-orders-details")) && (
                <Checkbox
                  checked={shippingCheckboxes?.do_not_email}
                  onChange={(e) =>
                    handleCheckboxChange("do_not_email", e.target.checked)
                  }
                >
                  Do Not Email
                </Checkbox>
              )}
            {title === "Ship To" ? (
              <>
                <Checkbox
                  checked={shippingCheckboxes?.sms_disabled}
                  onChange={(e) =>
                    handleCheckboxChange("sms_disabled", e.target.checked)
                  }
                >
                  SMS Disabled
                </Checkbox>
                <Checkbox
                  checked={shippingCheckboxes?.residiential}
                  onChange={(e) =>
                    handleCheckboxChange("residiential", e.target.checked)
                  }
                >
                  Residential
                </Checkbox>
              </>
            ) : (
              <>
                {/* {route.includes("sale-order-details") && (
                  <Checkbox
                    checked={shippingCheckboxes?.ship_partially}
                    onChange={(e) =>
                      handleCheckboxChange("ship_partially", e.target.checked)
                    }
                  >
                    Ship Partially
                  </Checkbox>
                )} */}
              </>
            )}
          </div>
        ) : (
          <p className="text-danger">Please Provide Shipping Details</p>
        )}
      </Card>
    </>
  );
};

export default OrderBillingAddressCard;
